"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
// The gateway RPC contract, re-exports only. Add a method: shapes in methods/<domain>.types.ts, one line in methods/<domain>.ts, list it in models.ts.
__exportStar(require("./protocol/limits.js"), exports);
__exportStar(require("./protocol/failures.js"), exports);
__exportStar(require("./protocol/socket.js"), exports);
__exportStar(require("./methods/define.js"), exports);
__exportStar(require("./methods/gateway.types.js"), exports);
__exportStar(require("./methods/zigbee.types.js"), exports);
__exportStar(require("./methods/gateway.js"), exports);
__exportStar(require("./methods/zigbee.js"), exports);
__exportStar(require("./methods/registry.js"), exports);
__exportStar(require("./permissions/access.js"), exports);
__exportStar(require("./permissions/byMethod.js"), exports);
__exportStar(require("./models.js"), exports);
